import { render, staticRenderFns } from "./reformToMaterial.vue?vue&type=template&id=722c24bc&scoped=true"
import script from "./reformToMaterial.vue?vue&type=script&lang=js"
export * from "./reformToMaterial.vue?vue&type=script&lang=js"
import style0 from "./reformToMaterial.vue?vue&type=style&index=0&id=722c24bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722c24bc",
  null
  
)

export default component.exports